export const isOutsideInput = (event: any) => {
  const tagName = event.target?.tagName;
  return tagName !== "INPUT" && tagName !== "SELECT" && tagName !== "TEXTAREA";
};
